import { z } from 'zod'
import type { schema } from '@basehub/data/db/index'

export const userSchema = z.object({
  id: z.string(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  username: z.string().nullable(),
  imageUrl: z.string().nullable(),
  updatedAt: z.string().nullable(),
  createdAt: z.string().nullable(),
  deletedAt: z.string().nullable(),
  bio: z.string().nullable(),
  email: z.string().nullable(),
  lastSignInAt: z.string().nullable(),
  joined: z.string(),
  lastAnnouncementReceived: z.string().nullable(),
  lastChangelogSeen: z.string().nullable(),
  showReleaseNote: z.boolean().default(true),
  preferences: z.object({
    emailNotifications: z.boolean(),
  }),
})

export const userSchemaDB = z.object({
  id: z.string(),
  updated_at: z.date(),
  created_at: z.date(),
  deleted_at: z.date().nullable(),
  first_name: z.string().nullable(),
  last_name: z.string().nullable(),
  profile_image_url: z.string().nullable(),
  username: z.string().nullable(),
  bio: z.string().nullable(),
  email: z.string().nullable(),
  last_sign_in_at: z.date().nullable(),
  last_announcement_received: z.string().nullable(),
  preferences: z.object({
    emailNotifications: z.boolean(),
  }),
  unsubscribeToken: z.string(),
} satisfies Record<keyof schema.UserFromClerk, unknown>)

export const userSchemaDbToDefault = userSchemaDB.transform(
  (data) =>
    ({
      id: data.id,
      updatedAt: data.updated_at.toISOString(),
      createdAt: data.created_at.toISOString(),
      deletedAt: data.deleted_at?.toISOString() ?? null,
      firstName: data.first_name,
      lastName: data.last_name,
      imageUrl: data.profile_image_url,
      username: data.username,
      bio: data.bio,
      email: data.email,
      lastSignInAt: data.last_sign_in_at?.toISOString() ?? null,
      joined: data.created_at.toISOString(),
      lastAnnouncementReceived: data.last_announcement_received,
      lastChangelogSeen: null,
      showReleaseNote: true,
      preferences: data.preferences,
    }) satisfies User
)

export type User = z.infer<typeof userSchema>
